import '@fontsource/montserrat';
import '@fontsource/montserrat/latin-400.css';
import '@fontsource/montserrat/latin-500.css';
import '@fontsource/montserrat/latin-600.css';
import '@fontsource/montserrat/latin-700.css';
import '@fontsource/montserrat/latin-800.css';
import '@fontsource/montserrat/latin-900.css';
import './_Layout.scss';
import '../../../src/global.scss';

import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import Header from './Header';
import Footer from './Footer';
import SubLayout from './SubLayout';
import { getCategoryMap } from '../../utils';

interface ILayoutProps {
    seo?: { title: string; description: string };
    children: any;
}
export default function _Layout(props: ILayoutProps) {
    const { currentLocale } = usePageLocalization();
    const data = useStaticQuery(graphql`
        query {
            accessories: allProductsJson(
                filter: { category: { regex: "^/Drolet/Accessories/" } }
            ) {
                nodes {
                    code
                    id

                    documents {
                        en_CA
                        en_US
                        fr_CA
                    }
                    description {
                        valuesMarkdownRemark {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    title {
                        en_CA
                        en_US
                        fr_CA
                    }
                    slug {
                        en_CA
                        en_US
                        fr_CA
                    }
                    category
                    category_localized {
                        en_CA
                        en_US
                        fr_CA
                    }
                    fields {
                        ...productsFieldsImagesFragment
                    }                   
                }
            }
            ventings: allProductsJson(
                filter: { category: { regex: "/Venting/" } }
            ) {
                nodes {
                    code
                    id
                    documents {
                        en_CA
                        en_US
                        fr_CA
                    }
                    description {
                        valuesMarkdownRemark {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    title {
                        en_CA
                        en_US
                        fr_CA
                    }
                    slug {
                        en_CA
                        en_US
                        fr_CA
                    }
                    category
                    category_localized {
                        en_CA
                        en_US
                        fr_CA
                    }
                    fields {
                        ...productsFieldsImagesFragment
                    }                    
                }
            }
            footerCms: allProductsJson(
                filter: { code: { eq: "drolet_footer" } }
            ) {
                nodes {
                    ...cmsDataFragment
                    attributes {
                        bouttons {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                        links {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                    }
                }
            }
        }
    `);
    const accessoriesMap = getCategoryMap(
        data?.accessories?.nodes,
        currentLocale
    );
    const ventingsMap = getCategoryMap(data?.ventings?.nodes, currentLocale);

    /* useEffect(() => {
        const path = location.pathname.split('/');

        // remove locale path
        path.shift();
        path.shift();
        path.shift();

        // redirect to english site if browser is in english
        if (navigator?.language.includes('en')) {
            navigate('/ca/en/' + path.join('/'));
        }
    }, []); */

    return (
        <>
            <Header accessories={accessoriesMap} venting={ventingsMap} />
            <SubLayout {...props} />
            <Footer
                venting={ventingsMap}
                footerCms={data?.footerCms?.nodes[0]}
            />
        </>
    );
}
